import React from 'react';
import { StyledPaperContainer, StyledSectionTitle } from '../../PlusWebsiteEditor.styles';
import { WebsiteConfiguration } from '../../types/websiteConfiguration';
import { StyledContainer, StyledImageUploader } from './LogoSection.styled';
import { DeepFieldErrorGetter, SetFieldValue } from '../../types/handlers';

type Props = Pick<WebsiteConfiguration, 'logo' | 'logo_white' | 'logo_url' | 'logo_url_white'> & { primaryColor?: string, onChange: SetFieldValue<string>; getError: DeepFieldErrorGetter };

const LogoSection = ({ logo, logo_white, logo_url, logo_url_white, primaryColor, onChange, getError }: Props) => (
  <StyledPaperContainer>
    <StyledSectionTitle>Logo</StyledSectionTitle>
    <StyledContainer>
      <StyledImageUploader
        helperText={getError('logo')}
        title="Logo"
        url={logo || logo_url || ''}
        onChange={(base64: string) => onChange('logo', base64, true)}
      />
      <StyledImageUploader
        backgroundColor={primaryColor}
        helperText={getError('logo_white')}
        title="White Logo"
        url={logo_white || logo_url_white || ''}
        onChange={(base64: string) => onChange('logo_white', base64, true)}
      />
    </StyledContainer>
  </StyledPaperContainer>
);

export default LogoSection;
